<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2022-03-10 10:11:11
-->
<template>
  <div class="alarm">
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(256) !== -1"
        type="primary"
        size="mini"
        @click="addAlarmNotice"
        >{{ $t("lang.alarmNotice.add") }}</el-button
      >
    </div>
    <el-table
      size="mini"
      id="out-table"
      :data="alarmNotice"
      row-key="id"
      :header-cell-style="{ background: '#e4f1ff' }"
      @sort-change="sortChange"
      height="650"
    >
      <el-table-column
        type="selection"
        min-width="40"
        reserve-selection
        :selectable="checkboxInit"
      ></el-table-column>
      <el-table-column
        :label="$t('lang.alarmNotice.serialNumber')"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.$index !== 0"
            style="color:#409eff;font-size:15px;"
            >{{ scope.$index }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        width="120px"
        :label="$t('lang.alarmNotice.eventName')"
        sortable="custom"
        prop="noticeName"
      >
        <template slot-scope="scope">
          <el-input
            v-if="scope.$index === 0"
            size="mini"
            v-model="seek.noticeName"
            clearable
          ></el-input>
          <span class="font-style" v-else>{{ scope.row.noticeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.way')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            modeObj[scope.row.mode]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.tsn')" min-width="150px">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.$index !== 0 && scope.row.dtus.length > 1"
            effect="dark"
            placement="top-start"
          >
            <div style="max-width: 500px" slot="content">
              <div
                class="font-style"
                style="display: inline"
                v-for="(item, index) in scope.row.dtus"
                :key="index"
              >
                <span>{{ item.sn }}（{{ item.name }}）</span>
                <span v-if="index < scope.row.dtus.length - 1">、</span>
              </div>
            </div>
            <span style="color:#409eff;font-size:0.25rem;cursor: poiter"
              >{{ scope.row.dtus[0].sn }}（{{
                scope.row.dtus[0].name
              }}）等</span
            >
          </el-tooltip>
          <span
            class="font-style"
            v-else-if="scope.$index !== 0 && scope.row.dtus.length === 1"
            >{{ scope.row.dtus[0].sn }}（{{ scope.row.dtus[0].name }}）</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.pushMechanism')">
        <template slot-scope="scope">
          <el-select
            size="mini"
            v-if="scope.$index === 0"
            v-model="seek.pushMode"
          >
            <el-option
              :label="$t('lang.alarmNotice.once')"
              value="1"
            ></el-option>
            <el-option
              :label="$t('lang.alarmNotice.repeatedly')"
              value="2"
            ></el-option>
          </el-select>
          <span class="font-style" v-if="scope.$index !== 0">{{
            pushModeObj[scope.row.pushMode]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.state')" align="center">
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="
                (val) => {
                  switchChange(val, scope.row);
                }
              "
            ></el-switch>
            <!-- <el-tag type="success" v-if="scope.row.status == 1">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>-->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmNotice.AlarmContact')"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.$index !== 0 && scope.row.alarmContacts.length > 3"
            effect="dark"
            placement="top-start"
          >
            <div style="max-width: 500px" slot="content">
              <div
                style="display: inline"
                class="font-style"
                v-for="(item, index) in scope.row.alarmContacts"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <span v-if="index < scope.row.alarmContacts.length - 1"
                  >、</span
                >
              </div>
            </div>
            <div>
              <div
                style="display: inline;color:#409eff;font-size:0.25rem;cursor: poiter"
                v-for="index in 3"
                :key="index"
              >
                <span style>{{ scope.row.alarmContacts[index - 1].name }}</span>
                <span v-if="index < 3">、</span>
                <span v-if="index === scope.row.alarmContacts.length - 1"
                  >&nbsp;等</span
                >
              </div>
            </div>
          </el-tooltip>
          <div
            v-else-if="
              scope.$index !== 0 && scope.row.alarmContacts.length <= 3
            "
          >
            <div
              class="font-style"
              style="display: inline"
              v-for="(item, index) in scope.row.alarmContacts"
              :key="index"
            >
              <span>{{ scope.row.alarmContacts[index].name }}</span>
              <span v-if="index < scope.row.alarmContacts.length - 1">、</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmNotice.Alarmoperate')"
        min-width="150px"
      >
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-button
              v-if="Permission.indexOf(257) !== -1"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="editalarmNotice(scope.row)"
            ></el-button>
            <el-button
              v-if="Permission.indexOf(258) !== -1"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeAlarmNotice(scope.row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 添加编辑 -->
    <cont-dialog ref="contDialog" @updateList="queryKeyword"></cont-dialog>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import {
  getAlarmNotice,
  deleteAlarmNotice,
  editAlarmNotice,
  queryAlarm,
} from "@/api/cloudMonitor/alarmList";
import { modeObj, pushModeObj } from "@/utils/alarmConfig";
import contDialog from "./componets/contDialog";
import { cloneDeep } from "lodash";
import { getPermission } from "@/cookie/cookie";

export default {
  components: {
    pagination,
    contDialog,
  },
  mixins: [PublicComponent],
  data() {
    return {
      modeObj,
      pushModeObj,
      devices: [],
      contacts: [],
      alarmNotice: [],
      seek: {
        noticeName: "",
        sortNum: "",
        pushMode: "",
      },
      Permission: [],
    };
  },
  mounted() {
    this.queryKeyword();
    this.Permission = getPermission();
  },
  methods: {
    // 获取报警通知列表
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        noticeName: this.seek.noticeName ? this.seek.noticeName : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
        pushMode: this.seek.pushMode ? Number(this.seek.pushMode) : undefined,
      };
      queryAlarm(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.alarmNotice = data.records;
          this.alarmNotice.forEach((item) => {
            if (item.status && item.status == 1) {
              item.status = true;
            } else {
              item.status = false;
            }
          });
          this.alarmNotice.unshift({});
          this.total = data.total;
        }
      });
    },
    // 排序
    sortChange({ column, prop }) {
      if (prop == "noticeName") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    addAlarmNotice() {
      this.$refs.contDialog.show();
    },
    // 编辑
    editalarmNotice(row) {
      this.$refs.contDialog.show(row);
    },
    // 刪除
    removeAlarmNotice(row) {
      this.$confirm(
        this.$t("lang.configuration.databases"),
        this.$t("lang.port.tips"),
        {
          cancelButtonText: this.$t("lang.configuration.cancel"),
          confirmButtonText: this.$t("lang.configuration.Determine"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          deleteAlarmNotice(row.id)
            .then((res) => {
              if (res.data.code === 0) {
                this.$message.success(this.$t("lang.Button.successDelete"));
                this.offset = 1;
                this.queryKeyword();
              } else {
                this.$message.error(this.$t("lang.collect.msg8"));
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    // 设置轻提示内容
    getContent() {},
    // 开关变化
    switchChange(val, row) {
      let data = cloneDeep(row);
      let type = ""; //开启或关闭
      if (data.status) {
        type = this.$t("lang.openvpn.open");
      } else {
        type = this.$t("lang.openvpn.close");
      }
      this.$confirm(
        this.$t("lang.user.Confirmation") + "?",
        this.$t("lang.port.tips"),
        {
          confirmButtonText: this.$t("lang.terminalList.Confirm"),
          cancelButtonText: this.$t("lang.terminalList.Cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          data.status = data.status ? "1" : "0";
          editAlarmNotice(data).then((res) => {
            if (res.data.code === 0) {
              this.$message.success(this.$t("lang.IOControl.msgok"));
              this.queryKeyword();
            } else {
              this.$message.error(this.$t("lang.IOControl.msgfaile"));
            }
          });
        })
        .catch(() => {
          row.status = !row.status;
        });
    },
    //禁止第一行搜索栏选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
  },
};
</script>
<style scoped>
.font-style {
  font-size: 0.25rem;
}
</style>
